import { render, staticRenderFns } from "./CaisseEditTab.vue?vue&type=template&id=1ba16de2&"
import script from "./CaisseEditTab.vue?vue&type=script&lang=js&"
export * from "./CaisseEditTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports